export default {"src":"/_next/static/media/zalo-cmc.0bc201c3.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};